import { Content } from "../../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../../general/modules/commons/content/contentHeader";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../../general/modules/commons/layout/layout";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../../general/modules/commons/breadcrumb/breadcrumb";
import { useAppDispatch } from "../../../../../hooks/useTypedSelector";
import { logout } from "../../../../auth/infrastructure/slices/authSlice/authSlice";
import useCrudTable from "../../../../../hooks/useCrudTable";
import { PathTableColumns } from "../../domain/columns/pathTableColumns";
import { pathSchema } from "../../domain/schemas/pathSchema";
import useCrudFilters from "../../../../../hooks/useCrudFilters";
import { useTranslation } from "react-i18next";
import { PathTableFilters } from "../features/pathTableFilters";

export const PathPage = () => {
  const { t } = useTranslation("common");

  const dispatch = useAppDispatch();

  const title = t("Paths");

  const crudFilters = useCrudFilters(
    {
      searchBy: "SearchByRootPath",
      fields: {},
    },
    "pathFilter",
  );

  const crud = useCrudTable({
    prefix: "paths",
    entity: "Path",
    columns: PathTableColumns,
    schema: pathSchema,
    filters: crudFilters.filters,
    addAction: "/paths/add",
    columnAction: "/paths/edit/:id",
  });

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} />
          <Breadcrumb>
            <BreadCrumbItem>{title}</BreadCrumbItem>
          </Breadcrumb>
          <LayoutHeaderActions>{crud.addButton}</LayoutHeaderActions>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <Content>
          <ContentHeader title={title} className="mb-3" />
          <PathTableFilters {...crudFilters} />
          {crud.table}
        </Content>
      </LayoutContent>
    </Layout>
  );
};
